/**
 * YouTube の URL とサムネイル。画面では音を流さない（音声は Discord の VC だけ）。
 * 元動画は「新しいタブで YouTube を開く」リンクとして出す。
 */

const ID = /^[\w-]{11}$/;

/** 入力の形だけを見る（正規化と最終判定はサーバー） */
export function looksLikeYouTubeUrl(input: string): boolean {
  try {
    const u = new URL(input.trim());
    if (!/^(www\.|m\.|music\.)?youtube\.com$|^youtu\.be$/.test(u.hostname)) return false;
    return extractVideoId(input) !== null;
  } catch {
    return false;
  }
}

export function extractVideoId(input: string): string | null {
  try {
    const u = new URL(input.trim());
    if (u.hostname === "youtu.be") {
      const id = u.pathname.slice(1).split("/")[0];
      return ID.test(id) ? id : null;
    }
    const v = u.searchParams.get("v");
    if (v && ID.test(v)) return v;
    const m = /^\/(?:live|shorts|embed)\/([\w-]{11})/.exec(u.pathname);
    return m ? m[1] : null;
  } catch {
    return null;
  }
}

export function thumbnailUrl(videoId: string, large = false): string {
  return `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/${large ? "maxresdefault" : "mqdefault"}.jpg`;
}

/** 元動画の指定位置を開く（秒に切り捨て） */
export function watchUrl(videoId: string, atMs?: number): string {
  const base = `https://www.youtube.com/watch?v=${encodeURIComponent(videoId)}`;
  return atMs === undefined ? base : `${base}&t=${Math.floor(Math.max(0, atMs) / 1000)}s`;
}
